<template>
    <div>
        <rkm-row>
            <rkm-col cols="12">
                <div class="d-flex justify-content-center">
                    <Dente
                        v-for="dente in dentesSuperioresPermanentesData"
                        :key="dente.numero"
                        @click="$refs.ModalDente.open(dente)"
                        position="cima"
                        v-bind="handleDenteProps(dente)"
                    >
                        <template v-slot:popover>
                            <strong>Problemas/condições</strong>

                            <div
                                v-for="(problemaCondicao, index) in dente.problemasCondicoes"
                                :key="index"
                            >
                                {{ problemaCondicao }}
                            </div>
                        </template>
                    </Dente>
                </div>
            </rkm-col>
        </rkm-row>

        <rkm-row
            v-if="!!data.model.saudeBucal.odontograma.mostrarDentesDeciduos"
            class="mt-4"
        >
            <rkm-col cols="12">
                <div class="d-flex justify-content-center">
                    <Dente
                        v-for="dente in dentesSuperioresDeciduosData"
                        :key="dente.numero"
                        @click="$refs.ModalDente.open(dente)"
                        position="cima"
                        v-bind="handleDenteProps(dente)"
                    >
                        <template v-slot:popover>
                            <strong>Problemas/condições</strong>

                            <div
                                v-for="(problemaCondicao, index) in dente.problemasCondicoes"
                                :key="index"
                            >
                                {{ problemaCondicao }}
                            </div>
                        </template>
                    </Dente>
                </div>
            </rkm-col>
        </rkm-row>

        <rkm-row
            v-if="!!data.model.saudeBucal.odontograma.mostrarDentesDeciduos"
            class="mt-4"
        >
            <rkm-col cols="12">
                <div class="d-flex justify-content-center">
                    <Dente
                        v-for="dente in dentesInferioresDeciduosData"
                        :key="dente.numero"
                        @click="$refs.ModalDente.open(dente)"
                        position="baixo"
                        v-bind="handleDenteProps(dente)"
                    >
                        <template v-slot:popover>
                            <strong>Problemas/condições</strong>

                            <div
                                v-for="(problemaCondicao, index) in dente.problemasCondicoes"
                                :key="index"
                            >
                                {{ problemaCondicao }}
                            </div>
                        </template>
                    </Dente>
                </div>
            </rkm-col>
        </rkm-row>

        <rkm-row class="mt-4">
            <rkm-col cols="12">
                <div class="d-flex justify-content-center">
                    <Dente
                        v-for="dente in dentesInferioresPermanentesData"
                        :key="dente.numero"
                        @click="$refs.ModalDente.open(dente)"
                        position="baixo"
                        v-bind="handleDenteProps(dente)"
                    >
                        <template v-slot:popover>
                            <strong>Problemas/condições</strong>

                            <div
                                v-for="(problemaCondicao, index) in dente.problemasCondicoes"
                                :key="index"
                            >
                                {{ problemaCondicao }}
                            </div>
                        </template>
                    </Dente>
                </div>
            </rkm-col>
        </rkm-row>

        <rkm-row class="mt-3">
            <rkm-col cols="12">
                A parte marcada como <span class="text-danger"><strong>vermelho</strong></span> representa não tratado.
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                A parte marcada como <span class="text-primary"><strong>azul</strong></span> representa tratado.
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                O ícone

                <rkm-icon
                    class="plus-icon"
                    icon="plus-circle"
                />

                representa que não há nenhum problema/condição e/ou procedimento lançado para o dente.
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                O ícone

                <rkm-icon
                    class="plus-icon"
                    color="var(--success)"
                    icon="plus-circle"
                />

                representa que há ao menos um problema/condição e/ou procedimento lançado para o dente.
            </rkm-col>
        </rkm-row>

        <ModalDente
            :data="data"
            ref="ModalDente"
        />
    </div>
</template>

<script>
// Components.
import Dente from './Dente'
import ModalDente from './Modal'

// Enums.
import saudeBucalDenteProblemaCondicao from '@/enums/ambulatorio/saudeBucalDenteProblemaCondicao'

export default {
    components: {
        Dente,
        ModalDente,
    },
    computed: {
        dentesSuperioresPermanentesData() {
            return this.getArcadas().superior.dentes.permanentes
        },
        dentesSuperioresDeciduosData() {
            return this.getArcadas().superior.dentes.deciduos
        },
        dentesInferioresDeciduosData() {
            return this.getArcadas().inferior.dentes.deciduos
        },
        dentesInferioresPermanentesData() {
            return this.getArcadas().inferior.dentes.permanentes
        },
    },
    data: () => ({
        enums: {saudeBucalDenteProblemaCondicao},
    }),
    methods: {
        handleDenteProps(dente) {
            const props = {
                fragments: dente.fragmentos,
                iconColor: dente.problemasCondicoes.length > 0 || (dente.procedimentos && dente.procedimentos.length > 0) ? 'var(--success)' : null,
                showPopover: this.data.model.saudeBucal.odontograma.id && dente.problemasCondicoes.length > 0,
                title: dente.numero,
            }

            const problemasCondicoesToDisable = [
                this.enums.saudeBucalDenteProblemaCondicao.AUSENTE_A,
                this.enums.saudeBucalDenteProblemaCondicao.EXTRAIDO_E,
                this.enums.saudeBucalDenteProblemaCondicao.HIGIDO_H,
                this.enums.saudeBucalDenteProblemaCondicao.PROTESE_PARCIAL_REMOVIVEL,
                this.enums.saudeBucalDenteProblemaCondicao.PROTESE_TEMPORARIA,
                this.enums.saudeBucalDenteProblemaCondicao.INCLUSO_I,
            ]

            if (this.data.model.saudeBucal.odontograma.id) {
                props.disabledButton = true
                props.disabledFragment = true
            }
            else if (this.data.model.saudeBucal.odontograma.protesesTotais.includes('superior') && this.getDentesSuperiores().some(denteSuperior => denteSuperior.numero === dente.numero)) {
                props.disabledFragment = true
            }
            else if (this.data.model.saudeBucal.odontograma.protesesTotais.includes('inferior') && this.getDentesInferiores().some(denteInferior => denteInferior.numero === dente.numero)) {
                props.disabledFragment = true
            }
            else if (dente.problemasCondicoes.some(problemaCondicao => problemasCondicoesToDisable.includes(problemaCondicao))) {
                props.disabledFragment = true
            }

            return props
        },
        getArcadas() {
            if (this.data.model.saudeBucal.odontograma.id){
                return this.data.form.saudeBucal.odontogramas.find(odontograma => odontograma.id === this.data.model.saudeBucal.odontograma.id).arcadas
            } else {
                return this.data.model.saudeBucal.odontograma.arcadas
            }
        },
        getDentesSuperiores() {
            return this.getDentesSuperioresPermanentes().concat(this.getDentesSuperioresDeciduos())
        },
        getDentesInferiores() {
            return this.getDentesInferioresPermanentes().concat(this.getDentesInferioresDeciduos())
        },
        getDentesSuperioresPermanentes() {
            return this.getArcadas().superior.dentes.permanentes
        },
        getDentesSuperioresDeciduos() {
            return this.getArcadas().superior.dentes.deciduos
        },
        getDentesInferioresDeciduos() {
            return this.getArcadas().inferior.dentes.deciduos
        },
        getDentesInferioresPermanentes() {
            return this.getArcadas().inferior.dentes.permanentes
        },
    },
    props: {
        data: {type: Object, required: true},
    },
}
</script>